import React, { Component } from "react";
import { Box } from "reflexbox";

class ShipmentStatus extends Component {
  render() {
    const status = JSON.parse(this.props.shipment.status);

    return (
      <Box flex wrap>
        <Box
          style={{
            fontWeight: "bold",
            color:
              status && status.loadingStatus && status.loadingStatus.labelColor
                ? status.loadingStatus.labelColor
                : "#d61717"
          }}
        >
          {status && status.loadingStatus && status.loadingStatus.text
            ? status.loadingStatus.text
            : ""}
        </Box>
        <Box ml={1}>{status && status.cmr ? "Cmr" : ""}</Box>
        <Box ml={1}>{status && status.manifest ? "Manifest" : ""}</Box>
        <Box ml={1}>{status && status.stickers ? "Stickers" : ""}</Box>
      </Box>
    );
  }
}

export default ShipmentStatus;



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentStatus.js